import { IMapPlatform } from './map.types'

export const DEFAULT_MAP_PLATFORM: IMapPlatform = 'MapLibre'
